<template>
  <div class="apply-agent-form">
    <div class="title">申请成为城市代理</div>
    <div class="sub-title">填写申请信息，我们的招商经理将尽快与您联系</div>
    <div class="form-container">
      <div class="form-item">
        <label class="form-label">
          姓名<span class="required">*</span>
        </label>
        <input
          v-model="formData.name"
          type="text"
          class="form-input"
          placeholder="请输入您的姓名"
        />
      </div>
      <div class="form-item">
        <label class="form-label">
          电话<span class="required">*</span>
        </label>
        <input
          v-model="formData.phone"
          type="tel"
          class="form-input"
          placeholder="请输入您的联系电话"
          maxlength="11"
          @input="handlePhoneInput"
        />
      </div>
      <div class="form-item">
        <label class="form-label">
          意向代理城市<span class="required">*</span>
        </label>
        <input
          v-model="formData.city"
          type="text"
          class="form-input"
          placeholder="请输入意向代理城市"
        />
      </div>
      <div class="form-item">
        <label class="form-label">
          个人/公司简介<span class="required">*</span>
        </label>
        <div class="textarea-wrapper">
          <textarea
            v-model="formData.introduction"
            class="form-textarea"
            placeholder="请输入个人或公司简介"
            :maxlength="100"
            @input="handleTextareaInput"
          />
          <div class="char-count">{{ charCount }}/100</div>
        </div>
      </div>
    </div>
    <button class="submit-btn" :disabled="isSubmitting" @click="handleSubmit">
      {{ isSubmitting ? '提交中...' : '提交申请' }}
    </button>
  </div>
</template>

<script>
import { submitAgentApplication } from '@/api/index';

export default {
  name: 'ApplyAgentForm',
  data() {
    return {
      formData: {
        name: '',
        phone: '',
        city: '',
        introduction: '',
      },
      charCount: 0,
      isSubmitting: false,
    };
  },
  methods: {
    handleTextareaInput() {
      this.charCount = this.formData.introduction.length;
    },
    handlePhoneInput(event) {
      // 只允许输入数字
      const value = event.target.value.replace(/\D/g, '');
      // 限制长度为11位（手机号）
      this.formData.phone = value.slice(0, 11);
    },
    validateForm() {
      if (!this.formData.name || !this.formData.name.trim()) {
        this.$message.error('请输入您的姓名');
        return false;
      }
      if (!this.formData.phone || !this.formData.phone.trim()) {
        this.$message.error('请输入您的联系电话');
        return false;
      }
      if (!this.formData.city || !this.formData.city.trim()) {
        this.$message.error('请输入意向代理城市');
        return false;
      }
      if (!this.formData.introduction || !this.formData.introduction.trim()) {
        this.$message.error('请输入个人或公司简介');
        return false;
      }
      return true;
    },
    async handleSubmit() {
      // 防止重复提交
      if (this.isSubmitting) {
        return;
      }

      // 表单验证
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;

      try {
        const response = await submitAgentApplication({
          name: this.formData.name.trim(),
          city: this.formData.city.trim(),
          phone_number: this.formData.phone.trim(),
          content: this.formData.introduction.trim(),
        });

        if (response.code === 200) {
          this.$message({
            message: '申请代理已提交，请等待联系！',
            type: 'success',
            duration: 10000,
          });
          // 清空表单
          this.formData = {
            name: '',
            phone: '',
            city: '',
            introduction: '',
          };
          this.charCount = 0;
        } else {
          this.$message.error(response.msg || '提交失败，请稍后重试');
        }
      } catch (error) {
        console.error('提交申请失败:', error);
        this.$message.error(error.message || '提交失败，请稍后重试');
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.apply-agent-form {
  width: 1057px;
  height: 1200px;
  background: linear-gradient(89deg, rgba(33, 42, 146, 0.8) 0%, rgba(135, 65, 209, 0.48) 100%);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-top: 86px;
  padding: 62px 116px;

  .title {
    font-weight: 700;
    font-size: 30px;
    color: #FFFFFF;
    align-self: center;
    text-align: center;
    width: 100%;
  }

  .sub-title {
    margin-top: 15px;
    margin-bottom: 52px;
    font-weight: 500;
    font-size: 19px;
    color: #FFFFFF;
    align-self: center;
    text-align: center;
    width: 100%;
  }

  .form-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 42px;

    .form-item {
      display: flex;
      flex-direction: column;
      gap: 20px;

      .form-label {
        font-weight: 500;
        font-size: 26px;
        color: #FFFFFF;

        .required {
          color: #FF0000;
          margin-left: 4px;
        }
      }

      .form-input {
        width: 100%;
        height: 48px;
        background: #FFFFFF;
        border-radius: 8px;
        border: none;
        padding: 0 16px;
        font-size: 16px;
        color: #333333;
        outline: none;
        box-sizing: border-box;

        &::placeholder {
          color: #999999;
        }

        &:focus {
          border: 1px solid #7845FF;
        }
      }

      .textarea-wrapper {
        position: relative;
        width: 100%;
        display: block;
        line-height: 0;

        .form-textarea {
          width: 100%;
          height: 261px;
          background: #FFFFFF;
          border-radius: 8px;
          border: none;
          padding: 12px 16px;
          padding-bottom: 32px;
          font-size: 16px;
          color: #333333;
          outline: none;
          resize: vertical;
          box-sizing: border-box;
          font-family: inherit;
          line-height: 1.5;

          &::placeholder {
            color: #999999;
          }

          &:focus {
            border: 1px solid #7845FF;
          }
        }

        .char-count {
          position: absolute;
          bottom: 8px;
          right: 12px;
          font-size: 14px;
          color: #999999;
        }
      }
    }
  }

  .submit-btn {
    width: 291px;
    height: 59px;
    background: linear-gradient(270deg, #CD5DFB 0%, #7249FF 100%);
    box-shadow: inset 0px 4px 10px 0px rgba(255, 255, 255, 0.6);
    border-radius: 30px;
    border: none;
    font-weight: 500;
    font-size: 28px;
    color: #FFFFFF;
    cursor: pointer;
    margin-top: 65px;
    outline: none;
    transition: opacity 0.3s;

    &:hover:not(:disabled) {
      opacity: 0.9;
    }

    &:active:not(:disabled) {
      opacity: 0.8;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}
</style>
